import { useContext, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import UserContext from '../../context/user';
import Overview from '../../pages/super-admin/Overview';
import ShippingLine from '../../pages/super-admin/ShippingLine';
import PendingRequests from '../../pages/super-admin/PendingRequests';
import BillingReview from '../../pages/super-admin/BillingReview';
import AssistantAdmin from '../../pages/super-admin/AssistantAdmin';
import HeaderBottom from './HeaderBottom';

const AppRouterSuperAdmin = () => {
  const { isLoggedIn, user } = useContext(UserContext);
  useEffect(() => {
    document.body.style.backgroundColor = "#f5f5f5"
  },[isLoggedIn])
  return (
    <Switch>
      {(isLoggedIn && user && user.roles?.includes("ADMIN"))
        ? [
          <Route key="super-admin" exact path="/super-admin">
            <HeaderBottom subtext="User Overview" />
            <Overview />
          </Route>,
          <Route key="shipping-lines" path="/super-admin/shipping-lines">
            <HeaderBottom subtext="Shipping Line Activity" />
            <ShippingLine />
          </Route>,
          <Route key="pending-requests" path="/super-admin/pending-requests">
            {/* PendingRequests renders its own HeaderBottom so the title can
                carry the live queue count. */}
            <PendingRequests />
          </Route>,
          <Route key="reuse-billing" path="/super-admin/reuse-billing">
            <BillingReview />
          </Route>,
          <Route key="assistant" path="/super-admin/assistant">
            <HeaderBottom subtext="StackIQ" />
            <AssistantAdmin />
          </Route>
        ] : null}
    </Switch>
  );
};

export default AppRouterSuperAdmin;
